const config = {
    API_BASE_URL:"https://scdn.dev/api"
};
export default config;
